import { useApi } from '~/providers/ApiProvider';

export interface Dashboard {
  id: string;
  name: string;
}

export const useDashboards = () => {
  const { warehouseApi } = useApi();

  const { data, isLoading, error, refetch } = warehouseApi.listDashboards.useQuery({
    queryKey: ['dashboards', 'list'],
  });

  const dashboards: Dashboard[] = data?.body?.data?.dashboards ?? [];

  return {
    dashboards,
    isLoading,
    error,
    refetch,
  };
};
